import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services';

export const isFirstSessionGuard: CanActivateFn = (route, state) => {
  const authService = inject( AuthService );
  const router      = inject( Router );

  if ( authService.currentUser()?.firstSession ) {
    return true;
  }

  router.navigate(['app']);
  return false;
};
